/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type StorefrontProductGrid_products = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly serviceId: string | null;
            readonly categoryPath: string | null;
            readonly categoryCode: string | null;
            readonly ecommerceTrackingParams: unknown | null;
            readonly " $fragmentRefs": FragmentRefs<"StorefrontProductTile_product">;
        } | null;
    } | null> | null;
    readonly " $refType": "StorefrontProductGrid_products";
};
export type StorefrontProductGrid_products$data = StorefrontProductGrid_products;
export type StorefrontProductGrid_products$key = {
    readonly " $data"?: StorefrontProductGrid_products$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontProductGrid_products">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontProductGrid_products",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DealerStorefrontQueryEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Item",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "categoryPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "categoryCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ecommerceTrackingParams",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "StorefrontProductTile_product"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DealerStorefrontQueryConnection",
  "abstractKey": null
};
(node as any).hash = '7f0a0a6d19b0517fc1d43c36783d7e8e';
export default node;
